

import React, { useState, useEffect } from 'react';

import { SearchableDropdown } from '../../../components/forms/SearchableDropdown';
import { type DropdownOption } from '../../../components/Dropdown';
import Alert from '../../../components/alert';
import { type MessageConfigurationResponse } from '../../../types/messageConfiguration';

interface MessageConfigTripGroupDropdownProps {
  id?: string;
  onSelect: (value: string) => void;
  value?: string;
  messageConfigs: MessageConfigurationResponse;
  errorMessage?: string;
}

const MessageConfigTripGroupDropdown: React.FC<MessageConfigTripGroupDropdownProps> = ({
  id = 'tripGroupDropdown',
  onSelect,
  value,
  messageConfigs,
  errorMessage,
}) => {
  const tripGroupOptionsWithDefaultFirst: DropdownOption<string>[] = (
    messageConfigs || []
  ).reduce<DropdownOption<string>[]>((accumulator, messageConfig) => {
    const { id, name } = messageConfig;
    const dropDownOption = {
      text: name,
      value: id,
    };

    return [...accumulator, dropDownOption];
  }, []);

  const [tripGroupInput, setTripGroupInput] = useState<string | undefined>();

  useEffect(() => {
    // make sure passed values
    const initialTripGroupInput =
      value && messageConfigs.find(config => config.id === value)
        ? value
        : tripGroupOptionsWithDefaultFirst.find(
            option => option?.text?.toLowerCase() === 'default',
          )?.value || tripGroupOptionsWithDefaultFirst?.[0]?.value;

    setTripGroupInput(initialTripGroupInput?.toString());
    onSelect(initialTripGroupInput?.toString() || '');
  }, [messageConfigs, value]);

  return (
    <>
      {errorMessage && <Alert type="danger" message={errorMessage} />}
      {!errorMessage && (
        <SearchableDropdown
          id={id}
          value={tripGroupInput}
          onChange={localValue => {
            if (localValue) {
              setTripGroupInput(localValue.toString());
              onSelect(localValue.toString());
            }
          }}
          options={tripGroupOptionsWithDefaultFirst}
        />
      )}
    </>
  );
};

export default MessageConfigTripGroupDropdown;
